import { ButtonLink } from '@/design-system'
import { flags } from '@/app/config'

/**
 * La primera misión (§auditoría H202).
 *
 * Cinco personas se registraron y ninguna fotografió un gato en la calle. La
 * app abría con un álbum vacío y una frase pasiva («la próxima vez que te
 * cruces…»), que no es una instrucción. Esta tarjeta encabeza Inicio mientras
 * no haya ni un solo encuentro, con UNA acción clara y las alternativas
 * debajo, y desaparece sola con el primer gato.
 *
 * Habla distinto a quien ya tiene gatos de casa: decirle «tu primera misión» a
 * alguien con tres gatos apuntados es no haber mirado su colección.
 */
export function FirstMissionCard({ tieneGatos = false }: { tieneGatos?: boolean }) {
  return (
    <section className="mission" aria-label={tieneGatos ? 'Sal a la calle' : 'Tu primera misión'}>
      <span className="mission__kick">{tieneGatos ? 'TE FALTA LA CALLE' : 'TU PRIMERA MISIÓN'}</span>
      <h2 className="mission__title">
        {tieneGatos ? 'Saca la cámara a la calle' : 'Sal y fotografía un gato'}
      </h2>
      <p className="mission__body">
        {tieneGatos
          ? 'Tus gatos de casa ya están a salvo aquí. Falta el otro lado: el gato de la esquina, el de la terraza, el que duerme sobre un coche. Ese se guarda con el lugar y el día.'
          : 'El que veas por la calle, en una terraza o durmiendo en un coche. Se guardará con el lugar y el día, y CatGO! lo reconocerá la próxima vez que os crucéis.'}
      </p>
      <ButtonLink to="/capturar" size="lg" icon="cat-camera">
        {tieneGatos ? 'Buscar un gato ahí fuera' : 'Buscar mi primer gato'}
      </ButtonLink>
      <div className="mission__alts">
        {!tieneGatos && (
          <ButtonLink to="/capturar?casa=1" variant="ghost" size="sm" icon="home">
            Empezar por un gato de casa
          </ButtonLink>
        )}
        {flags.discover && (
          <ButtonLink to="/descubrir" variant="ghost" size="sm" icon="compass">
            Ver quién más registra gatos
          </ButtonLink>
        )}
      </div>
      <p className="mission__note">Esta tarjeta desaparece en cuanto lo consigas.</p>
    </section>
  )
}
